<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "axios";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Pending Sample taking",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      search_status: false,
      filterdArray: [],
      advancedsearch: {
        search: "",
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      title: "Pending Sample taking",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Tests pending sample taking",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      sampleData: {
        testName: "",
        type: "",
        visit_id: "",
        order_id: "",
        pick_time: "",
        receive_time: "",
        labtest_id: "",
      },
      typeError: "",
      pickTimeError: "",
      receiveTimeError: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patientCode",
          sortable: true,
          label: "PATIENT No.",
        },
          {
              key: "patientName",
              sortable: true,
              label: "PATIENT NAME",
          },
        {
          key: "labrequest",
          sortable: false,
          label: "TEST DONE",
        },
      ],
      model_id: "",
    };
  },

  computed: {
    ...mapGetters("laboratory", [
      "all_pending_sample",
      "get_test_sample",
      "date_time",
      "PickingStatus",
    ]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("auth", ["user_permissions"]),
    /**
     * Total no. of records
     */

    rows() {
      return this.filterdArray ? this.filterdArray.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filterdArray ? this.filterdArray.length : 1;
  },
  watch: {
    all_pending_sample(newVal) {
      if (newVal) {
        this.AssignSampla();
      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    sampleModal(val) {
      this.fetchDate(),
      (this.sampleData.testName = val.test.name),
        (this.sampleData.type = ""),
        (this.sampleData.visit_id = val.visit),
        (this.sampleData.order_id = val.id),
        (this.sampleData.pick_time = this.date_time),
        (this.sampleData.receive_time = this.date_time),
        (this.sampleData.labtest_id = val.test.id),
        this.FetchSamples(val.test.id);
    },

    AssignSampla() {
      this.filterdArray = this.all_pending_sample;
    },
    ...mapActions({
      FetchPending: "laboratory/fetchPendingSample",
      FetchSamples: "laboratory/fetchTestSample",
      saveSample: "laboratory/addSample",
      resetState: "laboratory/resetSample",
      fetchDate: "laboratory/fetchDateTime",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    resetModal() {
      (this.sampleData.testName = ""),
        (this.sampleData.type = ""),
        (this.sampleData.visit_id = ""),
        (this.sampleData.order_id = ""),
        (this.sampleData.pick_time = ""),
        (this.sampleData.receive_time = ""),
        (this.sampleData.labtest_id = ""),
        (this.typeError = ""),
        (this.pickTimeError = ""),
        (this.receiveTimeError = ""),
        this.resetState();
    },

    resetTypeError() {
      this.typeError = "";
    },
    resetPickError() {
      this.pickTimeError = "";
    },
    resetReceiveError() {
      this.receiveTimeError = "";
    },
    SearchSample() {
      this.search_status = true;
      axios
        .post("filter_pending_sample", this.advancedsearch)
        .then((response) => {
          this.search_status = false;
          this.filterdArray = response.data.data;
        })
        .catch(() => {
          this.search_status = false;
        });
    },
    handleSubmit(modelId) {
      this.model_id = modelId;
      // Exit when the form isn't valid
      if (this.sampleData.type == "") {
        this.typeError = "Sample type field is required";
        return;
      } else {
        this.typeError = "";
      }
      if (this.sampleData.pick_time == "") {
        this.pickTimeError = "Date collected field is required";
        return;
      } else {
        this.pickTimeError = "";
      }
      if (this.sampleData.receive_time == "") {
        this.receiveTimeError = "Date received field is required";
        return;
      } else {
        this.receiveTimeError = "";
      }
      this.saveSample(this.sampleData);
    },
    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
  },
  created() {
    this.FetchPending();
    this.fetchDate();
    this.AssignSampla();
  },
};
</script>
<style scoped>
.loader-line {
  width: 200px;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  margin: 20px auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: rgb(0, 4, 255);
  -webkit-animation: lineAnim 1s linear infinite;
  -moz-animation: lineAnim 1s linear infinite;
  animation: lineAnim 1s linear infinite;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>


<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <lable for="date1">Filter Start Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date1"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <lable for="date2">Filter End Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date2"
                  class="form-control"
                />
              </div>
              <!-- <div class="col-md-3">
                <lable>Name/Code/Contact</lable>
                <input
                  type="text"
                  v-model="advancedsearch.search"
                  class="form-control"
                  placeholder="Search name,code or contact"
                />
              </div> -->

              <div class="col-md-3">
                <br />
                

                <button v-if="search_status" disabled class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
                <button v-else @click="SearchSample()" class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div v-if="search_status" class="loader-line"></div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->

            <div class="table-responsive mb-0">
              <b-table
                bordered
                class="datatables"
                :items="filterdArray"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                  <template #cell(patientCode)="data">
                      {{ data.item.patient.patientCode }}
                  </template>
                <template #cell(patientName)="data">
                  {{ data.item.patient.patientName }} ({{ data.item.patient.age }})
                  <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span
                  >
                  <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span class="badge rounded-pill bg-danger" v-else>
                    Not Cleared</span
                  >
                </template>
                <template #cell(labrequest)="data">
                  <table class="table">
                    <thead>
                      <tr>
                        <th width="50%">Test Name</th>
                        <th width="30%">Date and Time</th>
                        <th width="20%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(test, t) in data.item.labrequests" :key="t">
                        <td width="50%">
                          <span v-if="test.spouse">
                            <div style="color: green">
                              {{ test.test ? test.test.name : "---" }}
                              <sup v-show="test.spouse" class="badge bg-success"
                                >Spouse</sup
                              >
                            </div>
                          </span>
                          <span v-else>
                            {{ test.test ? test.test.name : "---" }}
                          </span>
                        </td>
                        <td width="30%">{{ test.dateCreated }}</td>
                        <td width="30%">
                          <!-- Add sample picked for a test -->
                          <b-button
                            v-if="
                              user_permissions
                                ? user_permissions.pick_sample
                                : false
                            "
                            size="sm"
                            v-b-modal.pickSample
                            variant="primary"
                            @click="sampleModal(test)"
                            ><i class="fa fa-plus"></i> Pick Sample</b-button
                          >
                          <button
                            v-else
                            class="btn btn-sm btn-outline-primary"
                            title="You are restricted"
                          >
                            <i class="fa fa-ban"></i> Pick Sample
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!all_pending_sample" class="text-primary">
                  <b-spinner
                    class="m-0"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <b-modal id="pickSample" ref="modal" @hidden="resetModal" hide-footer>
          <template #modal-title>
            <p class="text-uppercase">
              {{ sampleData.testName }} sample collection
            </p>
          </template>
          <div v-if="this.get_test_sample.length">
            <div class="mb-3">
              <label class="col-form-label">Sample Type:</label>
              <model-list-select
                :list="this.get_test_sample ? this.get_test_sample : []"
                v-model="sampleData.type"
                option-value="sample_id"
                option-text="sample"
                placeholder="Select sample type"
                @input="resetTypeError"
              >
              </model-list-select>
              <div class="text-danger" v-if="typeError">
                <em>{{ typeError }}</em>
              </div>
            </div>

            <div class="mb-3">
              <label class="col-form-label" for="collection-date"
                >Date Collected:</label
              >
              <input
                id="collection-date"
                v-model="sampleData.receive_time"
                class="form-control"
                type="datetime-local"
                @input="resetReceiveError"
              />
              <div class="text-danger" v-if="receiveTimeError">
                <em>{{ receiveTimeError }}</em>
              </div>
            </div>

            <div class="mb-3">
              <label class="col-form-label" for="date-received"
                >Date Received:</label
              >
              <input
                id="date-received"
                v-model="sampleData.pick_time"
                class="form-control"
                type="datetime-local"
                @input="resetPickError"
              />
              <div class="text-danger" v-if="pickTimeError">
                <em>{{ pickTimeError }}</em>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-secondary"
                @click="$bvModal.hide('pickSample')"
                type="button"
              >
                Close
              </button>
              <button
                class="btn btn-primary"
                type="button"
                @click="handleSubmit('pickSample')"
              >
                Save sample
                <b-spinner
                  v-if="PickingStatus"
                  variant="light"
                  small
                  role="status"
                ></b-spinner>
              </button>
            </div>
          </div>
          <div class="text-center" v-else>
            <span v-if="PickingStatus">
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem"
                label="Large Spinner"
              ></b-spinner>
            </span>
            <span v-else>
              <div class="text-danger">
                No sample matching {{ sampleData.testName }} found
              </div>
            </span>
          </div>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
